import React from "react";
import PropTypes from "prop-types";
import { Button, ArrowRight, ChevronLeft } from "@opendate-app/setlist";

const StepFooter = ({ onBack, onNext, nextDisabled, children }) => (
  <div className="series-step-footer">
    {onBack ? (
      <Button variant="secondary" icon={ChevronLeft} onClick={onBack}>
        Back
      </Button>
    ) : (
      <span />
    )}
    <div className="series-step-footer-end">
      {children}
      {onNext && (
        <Button variant="primary" disabled={nextDisabled} onClick={onNext}>
          <>
            Next <ArrowRight width={16} height={16} aria-hidden="true" />
          </>
        </Button>
      )}
    </div>
  </div>
);

StepFooter.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  nextDisabled: PropTypes.bool,
  children: PropTypes.node,
};

export default StepFooter;
